<template>
  <div class="marketing-automation-form-steps-add-send"
       data-icon="mdi-plus">

    <div class="marketing-automation-form-steps-add-send-header">
      <i class="mdi mdi-chevron-left pointer"
         @click="emitBack"></i>

      <p class="marketing-automation-form-steps-add-send-header-title">{{$t('message.automation.message.sendingOptions')}}</p>
    </div>

    <div class="marketing-automation-form-steps-add-send-actions">
      <button class="marketing-automation-form-steps-add-send-actions-item btn btn-secondary btn-round btn-sm mt-3"
              @click="emitSelect('EMAIL')">
        <i class="marketing-automation-form-steps-add-send-actions-item-icon mdi mdi-email-outline pointer"></i>
        {{$t('message.generics.message.email')}}
      </button>

      <button class="marketing-automation-form-steps-add-send-actions-item btn btn-secondary btn-round btn-sm mt-3"
              @click="emitSelect('SMS')">
        <i class="marketing-automation-form-steps-add-send-actions-item-icon mdi mdi-message-text-outline pointer"></i>
        {{$t('message.generics.message.sms')}}
      </button>

      <button class="marketing-automation-form-steps-add-send-actions-item btn btn-secondary btn-round btn-sm mt-3"
              @click="emitSelect('WHATSAPP')">
        <i class="marketing-automation-form-steps-add-send-actions-item-icon mdi mdi-whatsapp pointer"></i>
        WhatsApp
      </button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {},

  computed: {},

  data() {
    return {};
  },

  methods: {
    emitBack() {
      this.$emit("back");
    },
    emitSelect(channelType) {
      this.$emit("selected", {
        stepType: "CHANNEL",
        properties: {
          channelType,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-form-steps-add-send {
  .marketing-automation-form-steps-add-send-header {
    display: flex;
    align-items: center;

    i {
      color: $primary;
      font-size: 16px;
    }

    .marketing-automation-form-steps-add-send-header-title {
      color: #707070;
      font-weight: 600;
      text-align: center;
      font-size: 14px;
      margin: 0;
      flex: 1;
    }
  }

  .marketing-automation-form-steps-add-send-actions {
    display: flex;
    gap: 10px;

    .marketing-automation-form-steps-add-send-actions-item {
      box-shadow: none;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .marketing-automation-form-steps-add-send-actions-item-icon {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-right: 5px;
      }
    }
  }
}
</style>
